import { Metric } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void): void => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onFCP, onLCP, onINP, onTTFB }) => {
      onCLS(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      // 以下三个方法在较新版本中均存在
      if (onINP) onINP(onPerfEntry);
      if (onTTFB) onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
